import React from 'react';
import classnames from 'classnames';
import { useTranslation } from '@lt/localization';
import HintFactory from '../../../../components/Hint/HintFactory';

import styles from './layout.module.css';

/**
 * @deprecated
 * Временный компонент (не использовать!!!)
 */

// TODO: Чтобы убрать надо перенести компонент (HotelOfferCell) из lt-components
// и обернуть его уже в сверстаный кастомный Bubble
const IncludedServicesHint = ({ isMobile }) => {
  const { t } = useTranslation();
  return (
    <HintFactory
      autoPosition={isMobile}
      events
      attribute="data-hint-included"
      onRenderContent={() => (
        // TODO: унифицировать хинты
        <div className="react-hint__content">
          <div
            className={classnames(styles.servicesHintContainer, {
              [styles.servicesHintContainerMobile]: isMobile,
            })}
          >
            <p>{t('hotel.IncludedServices.services')}</p>
          </div>
        </div>
      )}
      isMobile={isMobile}
    />
  );
};

export default IncludedServicesHint;
